:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._hiddenElementThumbnail_117rk_7 {
  height: 60px;
  border-bottom: 1px solid #ddd;
  position: relative;
  background-color: #fff;
  cursor: pointer;
  max-height: 60px;
  opacity: 1;
  transition: max-height 500ms ease 300ms, opacity 300ms ease; }
  ._hiddenElementThumbnail_117rk_7:hover {
    background-color: #e7f0ff; }
  ._hiddenElementThumbnail_117rk_7._isInteraction_117rk_18 ._icon_117rk_18 {
    border-radius: 100%; }
  ._hiddenElementThumbnail_117rk_7._isInteraction_117rk_18 ._label_117rk_20 {
    padding-top: 14px;
    line-height: initial; }
  ._hiddenElementThumbnail_117rk_7 ._icon_117rk_18 {
    position: absolute;
    height: 40px;
    width: 40px;
    box-shadow: 0 0 4px 0 rgba(43, 86, 114, 0.2);
    border-radius: 4px;
    background-repeat: no-repeat;
    left: 25px;
    top: 10px;
    display: flex; }
    ._hiddenElementThumbnail_117rk_7 ._icon_117rk_18 svg {
      margin: auto;
      width: 14px;
      height: 14px; }
  ._hiddenElementThumbnail_117rk_7 ._hoverInteractionIcon_117rk_37 {
    color: #000624;
    margin-left: 6px; }
  ._hiddenElementThumbnail_117rk_7 ._hoverInteractionLabel_117rk_40 {
    color: #868aa5; }
  ._hiddenElementThumbnail_117rk_7 ._label_117rk_20 {
    position: relative;
    margin-left: 80px;
    line-height: 60px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 195px; }
  ._hiddenElementThumbnail_117rk_7 ._essential_117rk_50 {
    position: absolute;
    right: 85px;
    top: 23px;
    margin-right: 7px;
    margin-left: 7px; }
  ._hiddenElementThumbnail_117rk_7 ._showButton_117rk_56 {
    position: absolute;
    background-color: #e7f0ff;
    text-align: center;
    height: 24px;
    width: auto;
    top: 18px;
    left: auto;
    right: 12px;
    border-radius: 18px;
    color: #116dff; }
    ._hiddenElementThumbnail_117rk_7 ._showButton_117rk_56 ._showSymbol_117rk_67 {
      height: 10px;
      width: auto;
      margin-top: 7.5px;
      margin-left: 8.25px; }
    ._hiddenElementThumbnail_117rk_7 ._showButton_117rk_56 ._text_117rk_72 {
      margin: 3px 12px 0 2px; }
    ._hiddenElementThumbnail_117rk_7 ._showButton_117rk_56:hover {
      background-color: #d6e6fe; }
  ._hiddenElementThumbnail_117rk_7 ._showButtonWds_117rk_76 {
    position: absolute;
    top: 18px;
    right: 12px; }

._classic-facelift-skin_117rk_81 ._withRedesignExperiment_117rk_81 ._showButtonWds_117rk_76 ._control-button_117rk_81._btn-sm_117rk_81._prefix-icon_117rk_81 {
  padding: 0 12px 0 6px; }
